<script lang="ts">
    import {onMount} from 'svelte';
    import {
        getSubscribedPeople,
        increaseSubscribedPeople,
    } from './helpers/getSubscribedPeople/getSubscribedPeople';
    import {dyData} from 'general/store';

    const date = new Date();
    let subscribedPeopleAmount = getSubscribedPeople(date);

    onMount(() => {
        const intervalId = setInterval(() => {
            subscribedPeopleAmount = increaseSubscribedPeople(date, subscribedPeopleAmount);
        }, 3500);

        return () => clearInterval(intervalId);
    });
</script>

<style module>
    .container {
        position: absolute;
        left: 0;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: -0.23px;
        padding: 7px 10px 6px 8px;
        border-radius: 0 4px 4px 0;
        background-color: var(--black);
        color: var(--white);
    }
</style>

<div class="container" style="top: {$dyData.peopleSubscribed?.top || '51px'}">
    {subscribedPeopleAmount} People Signed Up Today
</div>
